import { costFormatter, percentFormatter } from '@format/currency';
import {
  DOLLAR_AMOUNT_TYPE,
  PERCENT_AMOUNT_TYPE,
  CATEGORY_PERCENT_AMOUNT_TYPE,
} from './constants';

export const isQueryOfferLoading = ({
  queryOfferCode,
  invalidQueryCodes = [],
  error,
  data,
}) =>
  Boolean(queryOfferCode) &&
  !invalidQueryCodes.includes(queryOfferCode) &&
  !error &&
  !data;

export const resolveActiveOfferCode = ({
  isQueryLoading,
  isCartLoading,
  queryOfferDetails,
  queryOfferCode,
  cartOfferCode,
  defaultOfferCode,
  allowDefault,
  preferCartOffer = false,
}) => {
  // Sampler display follows the cart. applySamplerOfferCode can leave a
  // valid URL code off the cart; using those coupon details advertises a
  // discount the cart does not have.
  if (preferCartOffer) {
    if (isCartLoading) return null;
    if (cartOfferCode) return cartOfferCode;
    if (!allowDefault) return null;
    return defaultOfferCode;
  }

  if (isQueryLoading || isCartLoading) {
    return null;
  }

  // Leftover SWR details must not outlive the URL offer_code, or addPromo
  // can put a sampler code on the starter cart after navigation.
  if (queryOfferCode && queryOfferDetails) {
    return queryOfferDetails.code || queryOfferCode;
  }

  if (cartOfferCode) {
    return cartOfferCode;
  }

  if (!allowDefault) {
    return null;
  }

  return defaultOfferCode;
};

export const getFormattedOfferAmountByType = offer => {
  if (!offer?.amount || !offer?.type) return '';

  const isDollarAmount = offer.type === DOLLAR_AMOUNT_TYPE;
  const isPercentAmount = offer.type === PERCENT_AMOUNT_TYPE;
  const isCategoryPercentAmount = offer.type === CATEGORY_PERCENT_AMOUNT_TYPE;

  if (isDollarAmount) return costFormatter(offer.amount);
  if (isPercentAmount) return percentFormatter(offer.amount);
  if (isCategoryPercentAmount) return percentFormatter(offer.amount);

  throw new Error(
    `Unknown Offer type: "${offer.type}"; Must be one of [${DOLLAR_AMOUNT_TYPE}, ${PERCENT_AMOUNT_TYPE}, ${CATEGORY_PERCENT_AMOUNT_TYPE}]`,
  );
};

export const calculateDiscountedPrice = (
  originalPrice,
  offerType,
  offerAmount,
) => {
  if (!originalPrice) return undefined;

  const price = Number(originalPrice);
  if (offerType === 'PERCENT_AMOUNT') {
    const discountPercentage = parseFloat(offerAmount) / 100;
    const remainingPercentage = 1 - discountPercentage;
    return String(price * remainingPercentage);
  } else {
    // For fixed amount discounts
    return String(Math.max(0, price - parseFloat(offerAmount)));
  }
};
